import { render, staticRenderFns } from "./TrafficStats.vue?vue&type=template&id=ad04184e&scoped=true&"
import script from "./TrafficStats.vue?vue&type=script&lang=js&"
export * from "./TrafficStats.vue?vue&type=script&lang=js&"
import style0 from "./TrafficStats.vue?vue&type=style&index=0&id=ad04184e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad04184e",
  null
  
)

export default component.exports